import { useTranslation } from '@web_opxp/features';
import { AssetsBaseUrl } from '../assets';
import CloseIcon from '../components/icons/CloseIcon';
import './Banner.scss';

interface IBannerProps {
  show: boolean;
  onClick: () => void;
  onClose: () => void;
}

export default function Banner({ show, onClick, onClose }: Readonly<IBannerProps>) {
  const { t } = useTranslation();
  const title = t('MedAwareness.Banner.Title');
  const imageSrc = `${AssetsBaseUrl}/feature/med-awareness/icon-med.svg`;
  if (!show) {
    return null;
  }
  return (
    <div className="med-banner-container">
      <button className="container" onClick={onClick} aria-label={title}>
        <img src={imageSrc} alt={title} />
        <h3 className="med-banner">{title}</h3>
      </button>
      <button className="med-banner-close" onClick={onClose} aria-label="close">
        <CloseIcon />
      </button>
    </div>
  );
}
